import { inject } from 'vue'

export default () => {
  const config = inject('appConfig')
  return config
}
